import {  
    Injectable  
} from '@angular/core';  
import {  
    Workbook  
} from 'exceljs';  
import {  
    DatePipe  
} from '@angular/common';  
import * as fs from 'file-saver';  
import * as moment from 'moment'  
@Injectable()  
export class ExcelService {  
     constructor() {}  
    async generateExcel(data, fileData, headerItem) {  
        const header = headerItem;  
        // Create workbook and worksheet  
        const workbook = new Workbook();  
        var anum={
            1:'A', 2: 'B', 3: 'C', 4: 'D', 5: 'E', 6: 'F', 7: 'G', 8: 'H', 
            9: 'I', 10: 'J', 11: 'K', 12: 'L', 13: 'M', 14: 'N', 15: 'O', 
            16: 'P', 17: 'Q', 18: 'R', 19: 'S', 20: 'T', 21: 'U', 22: 'V', 
            23: 'W', 24: 'X', 25: 'Y', 26: 'Z',27:'AA', 28: 'AB', 29: 'AC', 30: 'AD', 31: 'AE', 32: 'AF', 33: 'AG', 34: 'AH', 
            35: 'AI', 36: 'AJ', 37: 'AK', 38: 'AL', 39: 'AM', 40: 'AN', 41: 'AO', 
            42: 'AP', 43: 'AQ', 44: 'AR', 45: 'AS', 46: 'AT', 47: 'AU', 48: 'AV', 
            49: 'AW', 50: 'AX', 51: 'AY', 52: 'AZ'}
           
        const worksheet = workbook.addWorksheet('Complaints'); 
        const title = "Sagar Micronics";
            console.log('A1:'+ anum[headerItem.length]+'1')
        worksheet.mergeCells('A1:'+ anum[headerItem.length]+'1');
        worksheet.mergeCells('A2:'+ anum[headerItem.length]+'2');
        worksheet.mergeCells('A3:'+ anum[headerItem.length]+'3');
        worksheet.mergeCells('A4:'+ anum[headerItem.length]+'4');
        worksheet.getCell('A1').value = 'Sagar Micronics';
        worksheet.getCell('A2').value = '(Attendance Management System)';
        worksheet.getCell('A2').alignment = { horizontal:'center'} ;
        worksheet.getCell('A3').value = fileData.dateFilter;
        worksheet.getCell('A4').value = '';
        ['A1', 'A2', 'A3', 'A4'].map(key => {
            worksheet.getCell(key).font = {
                bold: true,
            };
            worksheet.getCell(key).alignment = { horizontal:'center'};
            worksheet.getCell(key).border = {  
                top: {  
                    style: 'thin'  
                },  
                left: {  
                    style: 'thin'  
                },  
                bottom: {  
                    style: 'thin'  
                },  
                right: {  
                    style: 'thin'  
                }  
            };  
        });
        // Cell Style : Fill and Header  
        var TodayDate = new Date();  
        let MMDDYY = moment(TodayDate).format('MMDDYY').toString();  
        var FileName = "Attendance_Report_" + MMDDYY;  
        // let letterhead = workbook.addRow();

        const headerRow = worksheet.addRow(header);  
        headerRow.eachCell((cell, number) => {  
            cell.fill = {  
                type: 'pattern',  
                pattern: 'solid',  
                fgColor: {  
                    argb: 'FFFFFFFF'  
                },  
                bgColor: {  
                    argb: 'FFFFFFFF'  
                },  
            };  
            cell.font = {  
                color: {  
                    argb: '00000000',  
                },  
                bold: true  
            }  
            cell.border = {  
                top: {  
                    style: 'thin'  
                },  
                left: {  
                    style: 'thin'  
                },  
                bottom: {  
                    style: 'thin'  
                },  
                right: {  
                    style: 'thin'  
                }  
            };  
        });  
        data.forEach(d => {  
            const row = worksheet.addRow(d);  
            row.fill = {  
                type: 'pattern',  
                pattern: 'solid',  
                fgColor: {  
                    argb: 'FFFFFFFF'  
                }  
            };  
            row.font = {  
                color: {  
                    argb: '00000000',  
                },  
                bold: false  
            }  
            row.eachCell({ includeEmpty: true },(cell, number) => {  
                cell.border = {  
                    top: {  
                        style: 'thin'  
                    },  
                    left: {  
                        style: 'thin'  
                    },  
                    bottom: {  
                        style: 'thin'  
                    },  
                    right: {  
                        style: 'thin'  
                    }  
                };  
                cell.alignment = { vertical: 'middle', wrapText: true };
            });  
        });  
        worksheet.columns.forEach(function (column, i) {
            column.width = 20;
        });
        console.log(worksheet)
        workbook.xlsx.writeBuffer().then((data: any) => {  
            const blob = new Blob([data], {  
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  
            });  
            fs.saveAs(blob, fileData.fileName + '.xlsx');  
        });  
    }  
}  